import React from 'react';
import { Table } from '@mantine/core';

type PropType = {
  data: {
    label: string;
    value: React.ReactNode;
  }[];
};

const DataTable = (props: PropType) => {
  return props.data.length > 0 ? (
    <Table
      sx={(theme) => ({
        tableLayout: 'auto',
        '> tbody > tr > td': {
          whiteSpace: 'nowrap',
          border: 'none',
          '&:first-of-type': { fontWeight: 'bold', padding: 0 },
          '&:last-of-type': {
            width: '100%',
            paddingLeft: theme.spacing.lg,
          },
          '> span': {
            '&:not(:last-of-type)': { ':after': { content: '", "' } },
          },
        },
      })}
    >
      <tbody>
        {props.data.map((row) => (
          <tr key={row.label}>
            <td>{row.label}</td>
            <td>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  ) : null;
};

export default DataTable;
